import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { mergeMap, Subscription } from 'rxjs';

import _ from 'lodash';

import { BankResponseDto, BranchResponseDto, FilesService, MemberResponseDto, PaidBankTypeEnumText, PaidByEnumText, ProductsService, PurchaseDetailResponseDto, PurchaseDetailUpdateRequestDto, PurchasePaidRequestDto, PurchaseResponseDto, PurchasesService, PurchaseStatusEnumText } from '@api';
import { TranslateService } from '@ngx-translate/core';

import { DefaultModule, PrimeModule } from '@module';
import { ImageFallback } from '@shared';
// import { ImageFallback } from '@shared/directives/image-fallback.directive';
import { TranslationsPipe } from '@shared/pipe/translations.pipe';
import { InitialNameService } from '@shared/service/initial-name.service';
import { ToastService } from '@shared/service/toast.service';

import { BaseFeatureGridComponent, DynamicDropdownComponent, GridComponent, HeaderPageComponent, LibDropdownModule, LibModalModule, LoadingDirective, MenuItem, ModalComponent, PopupService, ValueField } from 'pn-core-code';

import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { ImageModule } from 'primeng/image';
import { InputNumberModule } from 'primeng/inputnumber';
import { KeyFilterModule } from 'primeng/keyfilter';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';

import { EGeneralInformationComponent } from '../../elements/e-general-information/e-general-information.component';
import { EPaymentMethodComponent } from '../../elements/e-payment-method/e-payment-method.component';
import { SharedPaymentResultRecordFormComponent } from '../shared-payment-result-record-form/shared-payment-result-record-form.component';
import { SharedProductsPurchasedDetailComponent } from '../shared-products-purchased-detail/shared-products-purchased-detail.component';

interface PurchaseDetailResponseCustomDto extends PurchaseDetailResponseDto {
  sumAmountString?: string;
}
@Component({
  selector: "shared-purchase-detail",
  standalone: true,
  imports: [
    HeaderPageComponent,
    DefaultModule,
    PrimeModule,
    DividerModule,
    GridComponent,
    PanelModule,
    TranslationsPipe,
    LibModalModule,
    LoadingDirective,
    RadioButtonModule,
    LibDropdownModule,
    KeyFilterModule,
    CheckboxModule,
    EPaymentMethodComponent,
    EGeneralInformationComponent,
    ImageModule,
    InputNumberModule,
    TooltipModule,
    SharedProductsPurchasedDetailComponent,
    SharedPaymentResultRecordFormComponent,
    DynamicDropdownComponent,
    ImageFallback,
  ],
  templateUrl: "./shared-purchase-detail.component.html",
  styleUrl: "./shared-purchase-detail.component.scss",
  providers: [PopupService, InitialNameService],
})
export class SharedPurchaseDetailComponent extends BaseFeatureGridComponent<PurchaseDetailResponseDto> implements OnInit, OnDestroy, OnChanges {
  @Input() routerId: string;
  @Input() isViewDetail: boolean;
  @Input() breadcrumbs: MenuItem[];
  @Output() onGoBack = new EventEmitter();

  override field: ValueField<PurchaseDetailResponseDto>;
  @ViewChild("nameTpl", { static: true }) nameTpl: TemplateRef<any>;
  @ViewChild("numberDecimalPieTpl", { static: true }) numberDecimalPieTpl: TemplateRef<any>;
  @ViewChild("numberPieTpl", { static: true }) numberPieTpl: TemplateRef<any>;
  @ViewChild("priceTpl", { static: true }) priceTpl: TemplateRef<any>;
  @ViewChild("actionTpl", { static: true }) actionTpl: TemplateRef<any>;
  @ViewChild("weighingInTpl", { static: true }) weighingInTpl: TemplateRef<any>;
  @ViewChild("weighingOutTpl", { static: true }) weighingOutTpl: TemplateRef<any>;

  @ViewChild("paymentResultRecordModal") paymentResultRecordModal: ModalComponent;
  @ViewChild("rejectedModal") rejectedModal: ModalComponent;
  @ViewChild("productPurchasedModal") productPurchasedModal: ModalComponent;

  @ViewChild("formPaymentResultRecord") formPaymentResultRecord: NgForm;
  @ViewChild("formRejected") formRejected: NgForm;
  @ViewChild("formEditProduct") formEditProduct: NgForm;

  @ViewChild("paymentResultRecordForm") paymentResultRecordForm: SharedPaymentResultRecordFormComponent;

  // breadcrumbs: MenuItem[];
  type: string = "member";
  paymentMethod: string = "bank";
  purchaseId: string;
  purchaseData: PurchaseResponseDto = {} as PurchaseResponseDto;
  bankData: BankResponseDto = {} as BankResponseDto;
  member: MemberResponseDto = {} as MemberResponseDto;

  pidByEnumText = PaidByEnumText;
  paidByEnum = PurchaseResponseDto.PaidByEnum;
  statusPurchaseType = PurchaseResponseDto.StatusEnum;
  purchaseStatusEnumText = PurchaseStatusEnumText;

  paidBankTypeEnum = PurchaseResponseDto.PaidBankTypeEnum;
  paidBankTypeEnumText = PaidBankTypeEnumText;
  purchasePaidData: PurchasePaidRequestDto = {} as PurchasePaidRequestDto;

  purchaseProductData: PurchaseDetailResponseCustomDto = {} as PurchaseDetailResponseCustomDto;
  productData: PurchaseDetailUpdateRequestDto = {} as PurchaseDetailUpdateRequestDto;
  isEditPurchaseProduct = false;
  product: any = {
    id: undefined,
    name: undefined,
    imageUrl: undefined,
    price: undefined,
  };

  detailId: string;
  productList: any[] = [];

  bankList: any[] = [];
  currentLang: string;

  paidByType = PurchasePaidRequestDto.PaidByEnum;
  fileImage: any;
  reason: any;

  isLoading = false;

  branchTypeEnum = BranchResponseDto.TypeEnum;
  titleConfirm: string;
  titleConfirmApprovePaid: string;
  titleConfirmNotApprovePaid: string;

  locationId: string;

  approveConfirmSub: Subscription;
  rejectConfirmSub: Subscription;
  submitPaymentResultRecordSub: Subscription;
  submitEditProductSub: Subscription;
  dataProductSub: Subscription;
  translationSub: Subscription;

  constructor(
    private purchasesService: PurchasesService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private initialNameService: InitialNameService,
    private fileService: FilesService,
    private productsService: ProductsService,
  ) {
    super();

    this.translationSub = this.translateService.stream(["confirm", "confirmApprovePaid", "confirmNotApprovePaid"]).subscribe((data) => {
      this.titleConfirm = data["confirm"];
      this.titleConfirmApprovePaid = data["confirmApprovePaid"];
      this.titleConfirmNotApprovePaid = data["confirmNotApprovePaid"];
      console.log("confirmApprovePaid", data["confirmApprovePaid"]);
    });

    this.translateService.onLangChange.subscribe((t) => {
      this.currentLang = t.lang;
      this.getProductsDropdown();
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.route.params.subscribe(async (params: { [x: string]: string }) => {
      console.log("params", params);
      this.purchaseId = params["id"];
      this.locationId = params["locationId"];
      this.rows = [];
      if (this.purchaseId) {
        this.getData();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["routerId"]) {
    }
  }

  async getProductsDropdown() {
    this.currentLang = this.translateService.currentLang;
    if (this.dataProductSub) {
      this.dataProductSub.unsubscribe();
    }

    this.dataProductSub = this.productsService
      .productsPurchasingDropdownGet$(this.purchaseData.branch?.id, this.purchaseData.member?.id, this.purchaseData.bulkSaleBranch?.id, undefined, undefined)
      .subscribe({
        next: async (data) => {
          // console.log('productsList', products);
          this.productList = await Promise.all(
            _.map(data, async (item) => ({
              id: item.id,
              name: this.initialNameService.initName(item),
              imageUrl: item.imageUrl,
              price: item.price,
            })),
          );
        },
        error: (error) => {},
      });
  }

  override ngOnDestroy(): void {
    if (this.translationSub) this.translationSub.unsubscribe();
  }

  protected override setColumns(): void {
    this.columns = [
      {
        name: "productNumberAndProduct",
        prop: "product",
        cellTemplate: this.nameTpl,
        maxWidth: 250,
        width: 250,
      },
      {
        name: "purchaseDetailList.weighingWeight",
        prop: "weight",
        alignData: "top",
        cellClass: "text-right",
        cellTemplate: this.numberPieTpl,
        width: 100,
        maxWidth: 110,
      },
      {
        name: "purchaseDetailList.weightLoss",
        prop: "weightLoss",
        alignData: "top",
        // headerClass: 'text-right',
        cellClass: "text-right",
        cellTemplate: this.numberPieTpl,
        width: 100,
        maxWidth: 110,
      },
      {
        name: "weighing.weight",
        prop: "weightTotal",
        alignData: "top",
        // headerClass: 'text-right',
        cellClass: "text-right",
        width: 100,
        maxWidth: 120,
        cellTemplate: this.numberPieTpl,
      },
      {
        name: "purchaseDetailList.priceBath",
        prop: "pricePerUnit",
        alignData: "middle",
        cellTemplate: this.priceTpl,
        minWidth: 175,
        maxWidth: 180,
      },
      {
        name: "totalPrice",
        prop: "sumAmount",
        width: 140,
        maxWidth: 150,
        alignData: "top",
        // headerClass: 'text-right',
        cellClass: "text-right",
        cellTemplate: this.numberDecimalPieTpl,
      },
      {
        name: "note",
        prop: "remark",
        alignData: "middle",
        minWidth: 220,
        maxWidth: 250,
      },
    ];

    if (this.purchaseData.isBulkSale) {
      this.columns.splice(1, 0, {
        name: "weighing.weighingIn",
        prop: "weightIn",
        alignData: "top",
        cellTemplate: this.weighingInTpl,
        width: 100,
        maxWidth: 110,
      });
      this.columns.splice(2, 0, {
        name: "weighing.weighingOut",
        prop: "weightOut",
        alignData: "top",
        cellTemplate: this.weighingOutTpl,
        width: 110,
        maxWidth: 120,
      });

      if (this.purchaseData.status === this.statusPurchaseType.PendingReview) {
        this.columns.splice(9, 0, {
          name: "",
          prop: "_action",
          alignFrozen: "right",
          isFrozen: true,
          width: 100,
          cellTemplate: this.actionTpl,
        });
      } else {
        this.columns.splice(9, 1);
      }
    } else {
      if (this.purchaseData.status === this.statusPurchaseType.PendingReview) {
        this.columns.splice(7, 0, {
          name: "",
          prop: "_action",
          alignFrozen: "right",
          isFrozen: true,
          width: 100,
          cellTemplate: this.actionTpl,
        });
      } else {
        this.columns.splice(7, 1);
      }
    }
  }

  protected override getData(): void {
    this.isLoading = true;
    if (this.dataSub) {
      this.dataSub.unsubscribe();
    }

    this.dataSub = this.purchasesService.purchasesIdGet$(this.purchaseId).subscribe({
      next: (data) => {
        console.log("purchaseData", data);
        this.purchaseData = data;

        this.setColumns();
        this.bankData = data.paidToMemberBankId?.bank;
        this.member = data.member;
        this.rows = data.purchaseDetails;
        this.page.totalCount = this.rows.length;
        this.getProductsDropdown();
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      },
      complete: () => {},
    });
  }

  goBack() {
    console.log("locationId -->", this.locationId);
    if (this.routerId) {
      this.router.navigate([this.localize.translateRoute(`/member/detail`), this.routerId, { tabIndex: "1" }]);
    } else {
      if (this.locationId) {
        this.router.navigate([this.localize.translateRoute(`/${this.locationId}/purchase`)]);
      } else {
        if (!this.isViewDetail) {
          this.router.navigate([this.localize.translateRoute(`/purchase`)]);
        } else {
          this.onGoBack.emit();
        }
      }
    }
  }

  approveStatus(item: PurchaseResponseDto) {
    this.popupService.confirm({
      title: this.titleConfirm,
      msg: this.titleConfirmApprovePaid,
      onAccept: () => {
        if (this.approveConfirmSub) {
          this.approveConfirmSub.unsubscribe();
        }
        this.approveConfirmSub = this.purchasesService.purchasesIdApprovePost$(item.id).subscribe((data) => {
          this.toastService.success("Approve Success");
          this.getData();
        });
      },
      onReject: () => {},
    });
  }

  rejectedStatus(item: PurchaseResponseDto) {
    console.log("updateStatus ", item);
    this.popupService.confirm({
      title: this.titleConfirm,
      msg: this.titleConfirmNotApprovePaid,
      onAccept: () => {
        this.rejectedModal.open();
      },
      onReject: () => {},
    });
  }

  onPaymentResultRecord(item: PurchaseResponseDto) {
    // this.isLoading = true;
    setTimeout(() => {
      this.paymentResultRecordModal.open();
    }, 0);
  }

  onCloseFormPaymentResultRecord() {
    this.purchasePaidData = {} as PurchasePaidRequestDto;
    this.paymentResultRecordModal.close();
  }

  onSubmitRejected(form: NgForm) {
    if (this.rejectConfirmSub) {
      this.rejectConfirmSub.unsubscribe();
    }
    if (form.invalid) {
      return;
    }

    this.rejectConfirmSub = this.purchasesService.purchasesIdRejectPost$(this.purchaseId, { rejectedReason: this.reason }).subscribe((data) => {
      this.toastService.success("Reject Success");
      this.rejectedModal.close();
      this.reason = undefined;
      this.getData();
    });
  }

  onSubmitPaymentResultRecord(form: NgForm) {
    // this.isLoading = true;
    if (this.submitPaymentResultRecordSub) {
      this.submitPaymentResultRecordSub.unsubscribe();
    }

    this.purchasePaidData = this.paymentResultRecordForm.purchasePaidData;
    console.log(" this.purchasePaidData", this.purchasePaidData);

    if (form.invalid || (this.purchasePaidData.paidBy === this.paidByType.Bank && !this.paymentResultRecordForm.fileImage)) {
      this.isLoading = false;
      return;
    }

    if (this.paymentResultRecordForm.fileImage) {
      this.submitPaymentResultRecordSub = this.fileService
        .filesPost$(this.paymentResultRecordForm.fileImage, "payslip-image", "image")
        .pipe(
          mergeMap((file) => {
            if (file && file.length > 0) {
              this.purchasePaidData.paidSlipImageUrl = file[0].url;
              console.log("payslip", this.purchasePaidData.paidSlipImageUrl);
            }
            return this.purchasesService.purchasesIdPaidPost$(this.purchaseId, this.purchasePaidData);
          }),
        )
        .subscribe({
          next: (data) => {
            this.toastService.success();
            this.isLoading = false;
            this.paymentResultRecordModal.close();
            this.getData();
          },
          error: (error) => {
            this.isLoading = false;
          },
          complete: () => {},
        });
    } else {
      if (this.purchasePaidData.paidBy === this.paidByType.Cash) {
        this.submitPaymentResultRecordSub = this.purchasesService.purchasesIdPaidPost$(this.purchaseId, this.purchasePaidData).subscribe({
          next: (data) => {
            this.toastService.success();
            this.isLoading = false;
            this.paymentResultRecordModal.close();
            this.getData();
          },
          error: (error) => {
            this.isLoading = false;
          },
          complete: () => {},
        });
      }
    }
  }

  onViewProduct(item: PurchaseDetailResponseDto) {
    this.isEditPurchaseProduct = false;
    this.purchaseProductData = _.cloneDeep(item);
    this.calculatePrice();

    setTimeout(() => {
      this.productPurchasedModal.open();
    }, 0);
  }

  override edit(row: PurchaseDetailResponseDto) {
    this.isEditPurchaseProduct = true;
    this.detailId = _.cloneDeep(row.id);
    this.productData.productId = _.cloneDeep(row.product?.id);
    this.product = {
      id: _.cloneDeep(row.product?.id),
      name: this.initialNameService.initName(_.cloneDeep(row.product)),
      imageUrl: _.cloneDeep(row.product.imageUrl),
      price: _.cloneDeep(row.pricePerUnit),
    };
    this.purchaseProductData = _.cloneDeep(row);

    setTimeout(() => {
      this.calculatePrice();
      this.productPurchasedModal.open();
    }, 0);
  }

  onSubmitEditProduct(form: NgForm) {
    if (this.submitEditProductSub) {
      this.submitEditProductSub.unsubscribe();
    }

    if (form.invalid) {
      this.isLoading = false;
      return;
    }
    this.productData.productId = this.product?.id;
    this.productData.weight = _.toNumber(this.purchaseProductData.weight);
    this.productData.weightLose = _.toNumber(this.purchaseProductData.weightLoss);
    this.productData.specialPricePerUnit = _.toNumber(this.purchaseProductData.specialPricePerUnit);
    this.productData.useSpecialPrice = this.purchaseProductData.useSpecialPrice;
    this.productData.remark = this.purchaseProductData.remark;

    if (this.purchaseData.isBulkSale) {
      this.productData.weightIn = this.purchaseProductData.weightIn;
      this.productData.weightOut = this.purchaseProductData.weightOut;
    }

    console.log("productData", this.productData);

    this.submitEditProductSub = this.purchasesService.purchasesIdDetaildetailIdPut$(this.purchaseId, this.purchaseProductData.id, this.productData).subscribe((data) => {
      this.toastService.success("Save Success");
      this.productPurchasedModal.close();
      this.getData();
    });
  }

  onChangProduct() {
    console.log("product", this.product);
    if (this.product) {
      this.purchaseProductData.pricePerUnit = this.product.price;
      setTimeout(() => {
        this.calculatePrice();
      }, 0);
      // this.purchaseProductData.weight = this.product.price;
    }
  }

  calculateWeight() {
    console.log("calculateWeight");
    if (this.purchaseData.isBulkSale) {
      if (this.purchaseProductData.weight && this.purchaseProductData.weight > 0) {
        this.purchaseProductData.weightTotal =
          this.purchaseProductData.weightLoss && this.purchaseProductData.weightLoss > 0 ? this.purchaseProductData.weight - this.purchaseProductData.weightLoss : this.purchaseProductData.weight;
        this.purchaseProductData.weightOut = _.toNumber(this.purchaseProductData.weightIn) - this.purchaseProductData.weight;
        this.calculatePrice();
      } else {
        this.purchaseProductData.weightOut = 0;
        this.purchaseProductData.weightTotal = 0;
        this.calculatePrice();
      }
    } else {
      this.purchaseProductData.weightTotal = this.purchaseProductData.weight - this.purchaseProductData.weightLoss;
      this.calculatePrice();
    }
  }

  calculateWeightLoss() {
    if (this.purchaseProductData.weightLoss && this.purchaseProductData.weightLoss > 0) {
      this.purchaseProductData.weightTotal = this.purchaseProductData.weight - this.purchaseProductData.weightLoss;
    } else {
      this.purchaseProductData.weightTotal = this.purchaseProductData.weight;
    }

    this.calculatePrice();
  }

  calculatePrice() {
    if (this.purchaseProductData.useSpecialPrice) {
      this.purchaseProductData.sumAmount = this.purchaseProductData.weightTotal * this.purchaseProductData.specialPricePerUnit;
    } else {
      this.purchaseProductData.sumAmount = this.purchaseProductData.weightTotal * this.purchaseProductData.pricePerUnit;
    }
  }

  onWeightInChang() {
    this.onWeightOutChang();
  }

  onWeightOutChang() {
    if (this.purchaseProductData.weightOut && this.purchaseProductData.weightOut > 0) {
      this.purchaseProductData.weight = _.toNumber(this.purchaseProductData.weightIn) - this.purchaseProductData.weightOut;
      this.purchaseProductData.weightTotal =
        this.purchaseProductData.weightLoss && this.purchaseProductData.weightLoss > 0 ? this.purchaseProductData.weight - this.purchaseProductData.weightLoss : this.purchaseProductData.weight;
      this.calculatePrice();
    }
  }
}
